import AbstractComponent from "./abstract-component";

const createTemplate = (city) => {
  let text = window.policyMessage;

  const actionButtonTitle = `Отправить запрос`;

  text = text.replace(`[[POLICY_BUTTON_TEXT]]`, actionButtonTitle);


  return (
    `<section class="modal offer">
      <div class="modal__overlay"></div>
      <div class="modal__wrap">
        <button class="modal__closeButton" type="button" title="Закрыть">
          <svg aria-hidden="true" width="16" height="16">
            <use class="" href="sienge/img/sprite.svg#close"></use>
          </svg>
        </button>

        <h2 class="offer__title modal__title">Ваша низкая цена</h2>

        <div class="offer__wrap">
        
          <p class="offer__text">Предложите вашу цену. Если цена на данный товара может быть снижена, то Вы получите сообщение.</p>
          
          <form class="offer__inputWrap" action="">
            <p class="offer__input input-placeholder">
              <input class="js--priceInput" type="number" inputmode="numeric" placeholder=" " name="price" id="price" value="" autocomplete="off">
              <label>Цена</label>
            </p>

            <p class="offer__input input-placeholder">
              <input class="js--priceInput" type="url" inputmode="url" placeholder=" " name="url" id="url" value="">
              <label>Ссылка на веб-страницу</label>
            </p>

            <p class="offer__input input-placeholder">
              <input class="js--priceInput" type="email" inputmode="email" placeholder=" " name="email" id="email" value="">
              <label>Ваш email</label>
            </p>

            <p class="offer__input input-placeholder">
              <input class="js--priceInput" type="tel" inputmode="tel" placeholder=" " name="phone" id="phone" value="">
              <label>Ваш телефон</label>
            </p>
          </form>

          <p class="offer__text offer__text--italic">
            Обратите внимание, что цена товара на нашем сайте указана с учетом доставки до <b>г. ${city}</b>.
            Поэтому при сравнении стоимости товара в другом магазине берите конечную стоимость с доставкой.
          </p>

          <p class="offer__errorMessage" data-show="false"></p>
          
          <div class="offer__buttonWrap" data-mode="button">
            <button class="offer__button button-primary js--offerPriceButton" type="button">${actionButtonTitle}</button>
            <div class="modal__progress">
              <img src="/sienge/img/load_bar.gif" alt="">
            </div>
          </div>

          <div class="policyMessage">
            <p>
              ${text}
            </p>
          </div>
          
        </div>
      </div>
    </section>`
  );
};

// {/* <div class="modal__input input">
// <label for="price">Ваше предложение по цене:</label>
// <input type="number" name="price" id="price">
// </div>

// <div class="modal__input input">
// <label for="url">Ссылка на веб-страницу с более низкой ценой:</label>
// <input type="url" name="url" id="url">
// </div>

// <div class="modal__input input">
// <label for="email">Ваш e-mail:</label>
// <input type="email" name="email" id="email">
// </div>

// <div class="modal__input input">
// <label for="phone">Ваш телефон:</label>
// <input type="tel" name="phone" id="phone">
// </div> */}

export default class OfferModalComponent extends AbstractComponent {
  constructor({city = ``}) {
    super();

    this._city = city;
  }

  getTemplate() {
    return createTemplate(this._city);
  }

  setShowClass() {
    this.getElement().classList.add(`modal--show`);
  }

  setCloseButtonClickHandler(handler) {
    this.getElement().querySelector(`.modal__closeButton`)
    .addEventListener(`click`, handler);
  }

  setOverlayClickHandler(handler) {
    this.getElement().querySelector(`.modal__overlay`)
    .addEventListener(`click`, handler);
  }
}
